module.exports = __webpack_public_path__ + "app/img/eturtle_air_gonfle.1d9f5d32.jpg";